import axios from 'axios'

import environment from '@/environment'

const PORTFOLIO_MANAGER_API_URL = environment.services.portfolioManagerApiUrl

export const switchResources = async (tsv: string) => {
  return axios.post(`${PORTFOLIO_MANAGER_API_URL}/activation-group/switch-resources`, tsv, {
    headers: {
      'Content-Type': 'text/plain',
    },
  })
}
